import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 overflow-hidden bg-cream" data-id="element-94">
      <div className="absolute inset-0 z-0" data-id="element-95">
        <img src="https://images.unsplash.com/photo-1568254183919-78a4f43a2877?w=1400&q=80" alt="Panes artesanales dorados con corteza crujiente" className="w-full h-full object-cover opacity-25" data-id="element-96" />
        <div className="absolute inset-0 bg-gradient-to-r from-cream via-cream/90 to-transparent" data-id="element-97"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-99">
          <span className="inline-block py-1 px-3 border border-bakery-brown/30 text-bakery-brown text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-100">
            Ebook Digital Premium
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-espresso leading-[1.1] mb-6" data-id="element-101">
            Masa Pan: <br data-id="element-102" />
            <span className="text-terracotta italic font-normal" data-id="element-103">
              Lo que la Panadería no te cuenta
            </span>
          </h1>
          <p className="text-lg md:text-xl text-espresso/80 mb-10 leading-relaxed max-w-lg" data-id="element-104">
            Recetas reales, procesos exactos y técnica panadera para lograr
            panes suaves, dorados y memorables desde casa.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-105">
            <a href="#comprar-btn" className="bg-espresso text-cream px-8 py-4 text-center font-medium tracking-wide hover:bg-terracotta transition-colors duration-300" data-id="element-106">
              Comprar ahora
            </a>
            <a href="#recetas" className="border border-espresso text-espresso px-8 py-4 text-center font-medium tracking-wide hover:bg-espresso hover:text-cream transition-colors duration-300" data-id="element-107">
              Ver lo que incluye
            </a>
          </div>

          <p className="text-sm text-espresso/60 italic flex items-center gap-2" data-id="element-108">
            <span className="w-8 h-[1px] bg-espresso/30 inline-block" data-id="element-109"></span>
            Para amantes del pan artesanal, la nostalgia latina y las recetas
            que sí funcionan.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="hidden md:block relative" data-id="element-110">
          <div className="aspect-[4/5] overflow-hidden shadow-2xl" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/pavkCHUGj78y5wkT2xMMbL/Screenshot_2026-04-15_at_11.19.34_PM.png" alt="Panes artesanales con corteza dorada y miga abierta" className="w-full h-full object-cover" data-id="element-112" />
          </div>
          <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-beige -z-10" data-id="element-113"></div>
          <div className="absolute -top-6 -right-6 w-32 h-32 border border-terracotta/30 -z-10" data-id="element-114"></div>
        </motion.div>
      </div>
    </section>;
}